import React, { FC } from 'react'
import { CTA } from '@components/ui'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace'
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt'
import { CTAProps } from './CTA'

type GoToStepProps = {
  label: string
  step?: string
  previous?: boolean
  Component?: FC<CTAProps>
  classes?: string
}

const GoToStep: FC<GoToStepProps> = ({ label, step, previous, classes = '', Component = CTA }) => {
  const goto = step ? step : '/'
  return (
    <div className={classes}>
      <Component label={label} url={goto} reverse={previous} icon={previous ? <KeyboardBackspaceIcon /> : <ArrowRightAltIcon />} />
    </div>
  )
}

export default GoToStep
